import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CampaignUpdate } from '../week/forecast-week/CampaignUpdate';
import { CellValue } from 'jspreadsheet-ce';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ForecastWeekEditable {
	constructor(private http: HttpClient) {}

	getWeekForecast(): Promise<any> {
		
		return this.http.get(`${environment.api}forecast/get_weeks_data`).toPromise();
	}

	getMonths(): Promise<any> {
		return this.http.get(`${environment.api}forecast/get_forecasted_months`).toPromise();
	}

	getRealMonthsO(): Observable<any> {
		
		return this.http.get(`${environment.api}forecast/get_real_months`);
	}
	/* ---------------------------------------------------------------- */

	getNextWeeks(): Observable<any> {
		
		return this.http.get(`${environment.api}forecast/get_next_weeks`);
	}

	getYearForecast(): Promise<any> {
		return this.http.get(`${environment.api}forecast/get_forecast_year_e`).toPromise();
	}

	getForecastLeads(): Promise<any> {
		
		return this.http.get(`${environment.api}forecast/get_forecast_leads`).toPromise();
	}

	getForecastLeadsByDate(): Promise<any> {
		return this.http.get(`${environment.api}forecast/get_forecast_leads_by_date`).toPromise();
	}

	// TODO: REVISAR 
	updateWeekForecast(campaignToUpdate: CampaignUpdate) {
		return this.http.get(`${environment.api}forecast/put_forecast_week?id=` + campaignToUpdate.campaignId + `&date=` + campaignToUpdate.date + `&leads=` + campaignToUpdate.leadsAssigned).toPromise();
	}

	getForecastIncomeWeek(): Promise<any> {
		
		return this.http.get(`${environment.api}forecast/get_forecast_income`).toPromise();
	}

	getForecastReschedule(): Promise<any> {
		
		return this.http.get(`${environment.api}forecast/get_forecast_reschedule`).toPromise();
	}

	// TODO: REVISAR
	updateWeekForecastReschedule(campaignToUpdate: CampaignUpdate) {
		return this.http.get(`${environment.api}forecast/put_forecast_week_reschedule?id=` + campaignToUpdate.campaignId + `&date=` + campaignToUpdate.date + `&leads=` + campaignToUpdate.leadsAssigned).toPromise();
	}

	getForecastReplacement(): Promise<any> {
		return this.http.get(`${environment.api}forecast/get_forecast_replacement`).toPromise();
	}

	updateWeekForecastReplacement(campaignToUpdate: CampaignUpdate) {
		return this.http.get(`${environment.api}forecast/put_forecast_week_replacement?id=` + campaignToUpdate.campaignId + `&date=` + campaignToUpdate.date + `&leads=` + campaignToUpdate.leadsAssigned).toPromise();
	}
}
